export default "__VITE_ASSET__BcSOsUJV__"